// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
import { SET_COUNTRY } from '../constants';
export const setCountry = country => async dispatch => {
  // ##### 25-04-30 Komarov
  uniLog('src/Redux/actions/setCountry.js:language', country);
  dispatch({
    type: SET_COUNTRY,
    payload: country,
  });
};
